import React, { useState } from "react";
import styled from "styled-components";
import Button from "./Button/v2";

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 999;
`;

const ConfirmModal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, 0.95);
  border: 2px solid #ff4444;
  border-radius: 10px;
  padding: 2rem;
  z-index: 1000;
  text-align: center;
  min-width: 300px;
  max-width: 500px;
`;

const ModalText = styled.p`
  color: white;
  font-size: 1.2rem;
  margin-bottom: 1.5rem;
  line-height: 1.5;
`;

const WarningText = styled.strong`
  color: #ff4444;
  display: block;
  margin-top: 0.5rem;
`;

const ButtonRow = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
`;

const VIPExitButton = ({ onConfirmExit, gameState }) => {
  const [showConfirm, setShowConfirm] = useState(false);

  const handleExit = () => {
    setShowConfirm(false);
    onConfirmExit();
  };

  const isActiveGame =
    gameState &&
    !["waiting", "ready", "humanWin", "vampireWin"].includes(gameState);

  return (
    <>
      <Button
        onClick={() => setShowConfirm(true)}
        data-test-id="vip-exit-button"
        isRed
      >
        End Game (VIP)
      </Button>

      {showConfirm && (
        <>
          <Overlay onClick={() => setShowConfirm(false)} />
          <ConfirmModal data-test-id="exit-confirmation-modal">
            <ModalText>
              Are you sure you want to end the game?
              {isActiveGame && (
                <WarningText>The game is currently in progress!</WarningText>
              )}
              <br />
              All players will be disconnected.
            </ModalText>
            <ButtonRow>
              <Button
                onClick={handleExit}
                data-test-id="confirm-exit-button"
                backGroundColor="#aa3333"
              >
                Yes, End Game
              </Button>
              <Button
                onClick={() => setShowConfirm(false)}
                data-test-id="cancel-exit-button"
                backGroundColor="#333333"
              >
                Cancel
              </Button>
            </ButtonRow>
          </ConfirmModal>
        </>
      )}
    </>
  );
};

export default VIPExitButton;
